import { UnorderedListOutlined } from "@ant-design/icons";
import { Card, Input, Modal, Row, Space } from "antd";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import ButtonComponent from "../../fields/ButtonComponent";
import ItemCategoryCard from "../../fields/ItemCategoryCard";
import SearchComponent from "../../fields/SearchComponent";
import {
    addMobileItemCategories,
    deleteMobileItemCategories,
    getMobileItemCategoriesList,
    updateMobileItemCategories,
} from "../../store/reducer/itemCategoriesSlice";
import PageHeader from "../../view/pageheader";

const MobileItemCategories = () => {
    const dispatch = useDispatch();
    const inputRef = useRef(null);
    // const { project_id, client_id } = useParams();
    //Selectors
    const {
        mobileitemCategoriesListData,
        itemCategoriesListLoading,
        addItemCategoriesLoading,
        mobileaddItemCategoriesSuccess,
        mobileaddItemCategoriesError,
        mobileaddItemCategoriesErrorMessage,
        mobileupdateItemCategoriesSuccess,
        mobileupdateItemCategoriesError,
        mobileupdateItemCategoriesErrorMessage,
        deleteItemCategoriesLoading,
        mobiledeleteItemCategoriesSuccess,
        mobiledeleteItemCategoriesError,
        deleteItemCategoriesErrorMessage,
    } = useSelector(state => state.itemCategories);
    const roleID = localStorage.getItem("role_id");
    const category_type = localStorage.getItem("category_type");

    const { count: totalCount, data: categoryList } = mobileitemCategoriesListData;
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [addItemCategory, setAddItemCategory] = useState({
        category_name: "",
    });

    const handleSave = () => {
        if (addItemCategory.category_name) {
            setIsModalOpen(false);
            let postData = addItemCategory;
            dispatch(addMobileItemCategories({ postData }));
            setAddItemCategory({ ...addItemCategory, category_name: "" });
        } else {
            toast.error("Please enter item category.")
        }
    };

    const handleCancel = () => {
        setIsModalOpen(false);
        setAddItemCategory({ ...addItemCategory, category_name: "" });
    };

    function getData(data) {
        const payload = { ...data };
        console.log("payload", payload);
        dispatch(getMobileItemCategoriesList(payload));
    }

    useEffect(() => {
        getData();

        if (mobileaddItemCategoriesSuccess) {
            toast.success("Item category added Successfully");
        }
        if (mobileaddItemCategoriesError) {
            toast.error(mobileaddItemCategoriesErrorMessage);
        }

        if (mobileupdateItemCategoriesSuccess) {
            toast.success("Item category updated successfully");
        }

        if (mobileupdateItemCategoriesError) {
            toast.error(mobileupdateItemCategoriesErrorMessage);
        }

        if (mobiledeleteItemCategoriesSuccess) {
            toast.success("Item category deleted successfully");
        }

        if (mobiledeleteItemCategoriesError) {
            toast.error(mobileupdateItemCategoriesErrorMessage);
        }
    }, [
        mobileaddItemCategoriesSuccess,
        mobileaddItemCategoriesError,
        mobileupdateItemCategoriesSuccess,
        mobileupdateItemCategoriesError,
        mobiledeleteItemCategoriesSuccess,
        mobiledeleteItemCategoriesError,
    ]);

    useEffect(() => {
        if (isModalOpen) {
            setTimeout(() => {
                inputRef.current.focus();
            }, 300);
        }
    }, [isModalOpen]);

    return (
        <div className="pe-2 mb-3 mt-2">
            <PageHeader
                HeaderText="Mobile Item Categories"
                Breadcrumb={[{ name: "Mobile Item Categories" }]}
                backButtonUrl={`/mobile-clients`}
            />
            <Card
                title="Item Categories for Mobile"
                style={{ minHeight: 300 }}
                extra={
                    <Space size={"middle"} className="my-3">
                        <SearchComponent
                            placeHolder="Search Item Category"
                            onChange={e => {
                                const payloadData = {
                                    searchquery: e.target.value,
                                };
                                getData(payloadData);
                            }}
                        />
                        {roleID === "2" && (category_type === "3" || category_type === "2") ? null : (
                            <ButtonComponent
                                style={{ backgroundColor: "#f7931e", color: "white" }}
                                buttonName="Add Mobile Item Category"
                                icon={<UnorderedListOutlined />}
                                onClick={() => setIsModalOpen(true)}
                            />
                        )}
                        <Modal
                            destroyOnClose
                            title="Add Mobile Item Category"
                            open={isModalOpen}
                            onOk={handleSave}
                            okText="Save"
                            okButtonProps={{ shape: "round", style: { backgroundColor: "#f7931e" } }}
                            cancelButtonProps={{
                                shape: "round",
                                style: { backgroundColor: "#6E6E6E", color: "white" },
                            }}
                            onCancel={handleCancel}
                        >
                            <Input
                                ref={inputRef}
                                placeholder="Item Category"
                                value={addItemCategory.category_name}
                                onChange={e =>
                                    setAddItemCategory({ ...addItemCategory, category_name: e.target.value })
                                }
                                onPressEnter={handleSave}
                            />
                        </Modal>
                    </Space>
                }
            >
                <Row gutter={[10, 10]}>
                    {categoryList &&
                        categoryList.map(category => (
                            <ItemCategoryCard
                                key={category.id}
                                category={category.category_name}
                                id={category.id}
                                // projectId={category.project_id}
                                onUpdate={updateMobileItemCategories}
                                onDelete={roleID === "2" ? null : deleteMobileItemCategories}
                                icons={roleID === "2" ? false : true}
                            />
                        ))}
                </Row>
            </Card>
        </div>
    );
};

export default MobileItemCategories;
